import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
    selector: "wfdss-support-dashboard",
    templateUrl: "./support-dashboard.component.html",
    styleUrls: ["./support-dashboard.component.scss"],
    standalone: false
})
export class SupportDashboardComponent implements OnInit {
  //TODO: Create IRWIN Support Service and add here
  constructor(private route: ActivatedRoute, private router: Router) {}

  currentTabName;

  routeSubscription?: Subscription;

  ngOnInit() {
    this.routeSubscription = this.route.url.subscribe(() => {
      this.currentTabName = this.setCurrentTabName(this.route.snapshot.firstChild.data.tabName);
    });

    if(!this.route.firstChild){
      this.router.navigate(this.supportTabIndexToRouteMap["IRWIN"]);
      this.currentTabName = this.supportTabNames[0];
    }
  }

  ngOnDestroy() {
    this.routeSubscription?.unsubscribe();
  }

  supportTabNames = ["IRWIN", "LINKS", "MIMIC_ROLES"];
  supportTabIndexToRouteMap = {
    IRWIN: ["support-dashboard", "irwin-tool"],
    LINKS: ["support-dashboard", "links"],
    MIMIC_ROLES: ["support-dashboard", "mimic-roles"]
  };

  setCurrentTabName(routerLink) {
    switch (routerLink) {
      case 'IRWIN':
        return this.supportTabNames[0];
      case 'Link Configuration':
        return this.supportTabNames[1];
      case 'Mimic Roles':
        return this.supportTabNames[2];
    }
  }

  tabChanged(tabName) {
    this.router.navigate(this.supportTabIndexToRouteMap[tabName]);
    this.currentTabName = tabName;
  }
}
